<template>
  <el-row :gutter="5">
    <el-col :span="6" v-for="(album, index) in items" :key="index">
      <el-card class="mt-5" :body-style="{ padding: '0px' }">
        <div class="card-body">
          <span
            class="triangle card-delete-album"
            v-if="album.CreatedBy === userid"
            @click="hanlderDelete(album.Id)"
          >
            <i class="el-icon-delete card-delete-album__icon" role="button">
            </i>
          </span>
          <img
            v-if="album.CoverPage !== undefined && album.CoverPage !== null"
            :src="album.CoverPage"
            class="image"
            @click="HandleSelection(album.Id)"
          />
          <img
            v-else
            src="https://www.netclipart.com/pp/m/208-2086453_folder-icons-transparent-material-folder-icon.png"
            class="image"
            @click="HandleSelection(album.Id)"
          />
        </div>

        <div style="padding: 14px">
          <span>{{ album.Name }}</span>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    userid() {
      return this.currentUser.UserID;
    }
  },
  methods: {
    hanlderDelete(id) {
      this.$confirm("Desea aliminar este album?", "Confirmación", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning"
      })
        .then(() => {
          // delete
          this.$http.delete(`/api/gallery/DeleteAlbum?id=${id}`).then(() => {
            this.$emit("delete");
            this.$message({
              type: "success",
              message: "Album eliminado"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Operacion cancelada"
          });
        });
    },
    HandleSelection(album) {
      this.$router.push({ name: "gallery-albums", query: { AlbumID: album } });
    }
  }
};
</script>

<style>
.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
  cursor: pointer;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.triangle {
  width: 50px;
  height: 50px;
  background: linear-gradient(
    to top right,
    #0000 0%,
    #0000 50%,
    #fff 50%,
    #fff 100%
  );
}

.card-body {
  width: 100%;
  position: relative;
}

.card-delete-album {
  cursor: pointer;
  position: absolute;
  right: 0em;
}

.card-delete-album__icon {
  cursor: pointer;
  position: absolute;
  right: 0.5em;
  color: red;
  top: 10%;
}
</style>
